import * as Actions from "../actions/ministryAction";

const initialState = {
  activeModal: {
    modalType: null,
    modalProps: {
      showModal: false,
    },
  },
};

export default (state = initialState, action) => {
  console.log("action", action);
  console.log("state", state);
  switch (action.type) {
    case Actions.MINISTRYSHOW_MODAL:
      return { ...state, activeModal: action.modal };
    case Actions.MINISTRYCLOSE_MODAL:
      return initialState;
    default:
      return state;
  }
};
